import React, { useEffect, useState } from 'react'
import './banner.scss'
import { HashLink } from 'react-router-hash-link';
import { useLocation, Link } from "react-router-dom";

const Banner = () => {
  const { hash } = useLocation();

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setIsVisible(false);
  };

  const handleDecline = () => {
    setIsVisible(false);
  };
  return (
    <>
      <section id='home' className="mainbanner">
        <div className='thisdiv'></div>
        <video className="main-banner-video"
          muted="muted" playsinline="playsinline"
          autoPlay
          loop
          width="100%"
          id="myVideo">
          <source src="\assets\banner-bg.mp4" type="video/mp4" />
        </video>
      
        <img src="\assets\banner-bg.png" alt="img" className='img-fluid banner-bg' />
        <div className="custom-container">
          <div className="innerbanner">
            <h6>Build. Scale. Manage.</h6>
            <h4 className="mainbannerhead">
              The full stack <br /> <span className="dark">Web3 studio.</span>
            </h4>
            <p className="mainbannerpara">
            From product design and protocol engineering to digital asset treasury and operational execution, we deliver end to end solutions for companies in the decentralized economy.
            </p>
            <div className="bannerbtns">
              <HashLink className="greenbtn" to="#contact">Contact Us</HashLink>
              {/* <button className="dullbtn">
                Learn More
              </button> */}
            </div>
          </div>
        </div>
        {
          isVisible && (
            <div className="cookiesmain">
            <div className="cookeishead">
              <span className="cookeismainimg">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M24.0666 11.2791C24.153 11.8406 24.1978 12.4146 24.1978 13C24.1978 19.1802 19.1801 24.1979 12.9999 24.1979C6.81971 24.1979 1.802 19.1802 1.802 13C1.802 6.81977 6.81971 1.80206 12.9999 1.80206C13.478 1.80206 13.9489 1.83227 14.4114 1.8906C14.6603 1.92185 14.878 2.06977 14.9989 2.28956C15.1187 2.50831 15.127 2.7729 15.0208 2.99894C14.8937 3.26769 14.8228 3.56873 14.8228 3.8854C14.8228 4.56248 15.1468 5.16456 15.6478 5.54477C15.8895 5.72915 16.003 6.03748 15.9374 6.3354C15.8895 6.55311 15.8645 6.77811 15.8645 7.0104C15.8645 8.7354 17.2645 10.1354 18.9895 10.1354C19.0926 10.1354 19.1937 10.1302 19.2947 10.1208C19.5551 10.0958 19.8103 10.2021 19.976 10.4052C20.3583 10.876 20.9405 11.1771 21.5937 11.1771C22.0562 11.1771 22.4843 11.026 22.8301 10.7708C23.0499 10.6083 23.3385 10.5719 23.5916 10.676C23.8447 10.7802 24.0239 11.0094 24.0666 11.2791ZM17.9478 14.8229C17.2291 14.8229 16.6458 15.4062 16.6458 16.125C16.6458 16.8437 17.2291 17.4271 17.9478 17.4271C18.6666 17.4271 19.2499 16.8437 19.2499 16.125C19.2499 15.4062 18.6666 14.8229 17.9478 14.8229ZM10.1353 17.4271C9.41659 17.4271 8.83325 18.0104 8.83325 18.7291C8.83325 19.4479 9.41659 20.0312 10.1353 20.0312C10.8541 20.0312 11.4374 19.4479 11.4374 18.7291C11.4374 18.0104 10.8541 17.4271 10.1353 17.4271ZM10.3853 6.17706C9.95409 6.17706 9.60409 6.52706 9.60409 6.95831C9.60409 7.38956 9.95409 7.73956 10.3853 7.73956C10.8166 7.73956 11.1666 7.38956 11.1666 6.95831C11.1666 6.52706 10.8166 6.17706 10.3853 6.17706ZM13.2603 14.8229C12.8291 14.8229 12.4791 15.1729 12.4791 15.6041C12.4791 16.0354 12.8291 16.3854 13.2603 16.3854C13.6916 16.3854 14.0416 16.0354 14.0416 15.6041C14.0416 15.1729 13.6916 14.8229 13.2603 14.8229ZM7.27075 11.6979C6.8395 11.6979 6.4895 12.0479 6.4895 12.4791C6.4895 12.9104 6.8395 13.2604 7.27075 13.2604C7.702 13.2604 8.052 12.9104 8.052 12.4791C8.052 12.0479 7.702 11.6979 7.27075 11.6979ZM12.2187 9.35415C11.4999 9.35415 10.9166 9.93748 10.9166 10.6562C10.9166 11.375 11.4999 11.9583 12.2187 11.9583C12.9374 11.9583 13.5208 11.375 13.5208 10.6562C13.5208 9.93748 12.9374 9.35415 12.2187 9.35415Z" fill="#145430" />
                </svg>
              </span>
              <h6 className="cookeisheadpara">This site uses cookies</h6>
            </div>
            <p className="cookeisbodypara">
              We use cookies on our Services for a variety of reasons which you can learn about <Link to='/cookies' className="greentext">here.</Link>
            </p>
            <div className="cookeisbuttons">
              <button className="darkbtn" onClick={handleDecline}>
                DECLINE
              </button>
              <button className="greenbtn" onClick={handleAccept}>
                ACCEPT
              </button>
            </div>
          </div>
          )
        }

      </section>
    </>
  )
}

export default Banner